/* src/app/components/leads/contact-details/contact-details.component.css */
.ant-input-affix-wrapper {
  margin-bottom: 0;
}
.address-section {
  width: 100%;
}
.ant-divider-horizontal {
  margin-bottom: 16px;
  margin-top: 0;
}
.address-control {
  margin-bottom: 0px;
}
.ant-form-item-label {
  margin-right: 8px;
}
.ant-radio-button-wrapper {
  margin: 0px;
  width: 100%;
}
.divider {
  border-top: 2px solid #cff1f04d;
}
.notes {
  font-size: 0.929rem;
  margin-top: 4px;
}
.notes p {
  margin: 0;
}
:host ::ng-deep .address-section .ant-input[disabled],
:host ::ng-deep .address-section input[disabled],
:host ::ng-deep .address-section .ant-input-disabled,
:host ::ng-deep .address-section .ant-select-disabled .ant-select-selector,
:host ::ng-deep .address-section .ant-select-disabled .ant-select-selection-item {
  background-color: #ffffff;
  color: rgba(0, 0, 0, 0.85);
  -webkit-text-fill-color: rgba(0, 0, 0, 0.85);
}
:host ::ng-deep .ppl-checkbox.ant-checkbox-wrapper-disabled span:not(.ant-checkbox) {
  color: rgba(0, 0, 0, 0.85);
}
:host ::ng-deep .ppl-checkbox.ant-checkbox-wrapper-disabled .ant-checkbox-disabled .ant-checkbox-inner {
  background-color: rgba(0, 0, 0, 0.15);
  border-color: rgba(0, 0, 0, 0.25);
}
:host ::ng-deep .ppl-checkbox.ant-checkbox-wrapper-disabled .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {
  border-color: #fff;
}
/*# sourceMappingURL=contact-details.component-W5YGVIW2.css.map */
